'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToTimeString = require('./dateToTimeString');

var _dateToTimeString2 = _interopRequireDefault(_dateToTimeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (epoch) {
    return (0, _dateToTimeString2.default)(new Date(epoch * 1000));
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToTimeString.js
// module id = 59
// module chunks = 0